/** @format */

import React from 'react';
import { Row, Col } from 'antd';
import { AncillaryInfo } from '../types';
import plus from 'img/Plus.svg';
import remove from 'img/Minus.svg';

interface AncillaryListProps {
  ancillaries: AncillaryInfo[];
  onAdd: () => void;
  onRemove: (index: number) => void;
  onChange: (index: number, field: keyof AncillaryInfo, value: any) => void;
}

export const AncillaryList: React.FC<AncillaryListProps> = ({
  ancillaries,
  onAdd,
  onRemove,
  onChange,
}) => {
  return (
    <Col sm={24} md={24} lg={24} xl={24}>
      <Row gutter={[24, 24]}>
        <Col sm={24} md={24} lg={24} xl={24}>
          <div
            className='form-heading'
            style={{
              justifyContent: 'space-between',
              display: 'flex',
            }}>
            <span> Ancillary Information</span>
            <button
              className='add-ancillary-button'
              type='button'
              onClick={onAdd}>
              <span>Add</span>
              <img src={plus} alt='plus icon' />
            </button>
          </div>
        </Col>

        {ancillaries.map((ancillary, index) => (
          <Col key={index} sm={24} md={24} lg={24} xl={24}>
            <Row gutter={[24, 24]}>
              <Col sm={24} xl={24}>
                <div className='remove-ancillary-container'>
                  <span>Ancillary {index + 1}</span>
                  <button
                    className='remove-ancillary-button'
                    type='button'
                    onClick={() => onRemove(index)}>
                    <span>Remove</span>
                    <span>
                      <img src={remove} alt='remove button' />
                    </span>
                  </button>
                </div>
              </Col>

              <Col sm={24} md={24} lg={24} xl={24}>
                <div className='form-input-wrapper'>
                  <label>Carrier *</label>
                  <input
                    type='text'
                    name={`carrier-${index}`}
                    value={ancillary.carrier}
                    onChange={(e) => onChange(index, 'carrier', e.target.value)}
                    required
                  />
                </div>
              </Col>

              <Col sm={24} md={24} lg={24} xl={24} style={{ width: '100%' }}>
                <div className='form-input-wrapper'>
                  <span>Was the customer charged today? *</span>
                  <div className='radial-input-wrapper'>
                    <label>
                      <input
                        type='radio'
                        name={`isPostDate-${index}`}
                        value='false'
                        checked={ancillary.isPostDate === false}
                        onChange={() => onChange(index, 'isPostDate', false)}
                      />
                      Yes
                    </label>
                    <label>
                      <input
                        type='radio'
                        name={`isPostDate-${index}`}
                        value='true'
                        checked={ancillary.isPostDate === true}
                        onChange={() => onChange(index, 'isPostDate', true)}
                      />
                      No
                    </label>
                  </div>
                </div>
              </Col>

              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <div className='form-input-wrapper'>
                  <label>
                    {ancillary.isPostDate
                      ? 'Enter Billing Date*'
                      : "Enter Today's Date*"}
                  </label>
                  <input
                    style={{ width: '100%' }}
                    type='date'
                    name={`billingDate-${index}`}
                    value={ancillary.billingDate}
                    onChange={(e) => onChange(index, 'billingDate', e.target.value)}
                    required
                  />
                </div>
              </Col>

              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <div className='form-input-wrapper'>
                  <label>Premium *</label>
                  <input
                    style={{ width: '100%' }}
                    type='number'
                    name={`premium-${index}`}
                    value={ancillary.premium}
                    onChange={(e) => onChange(index, 'premium', parseFloat(e.target.value) || 0)}
                    required
                  />
                </div>
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </Col>
  );
};
